import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".progress-item + .progress-item {\n  margin-left: 2px;\n}\n";
styleInject(css_248z);

export { css_248z as default };
